export default {
    hasDropdownLoaded: state => state.commonObj.hasDropdownLoaded,
    commonObj: state => state.commonObj
}
